export class MedicalAlertType {
    public medicalAlertTypeId = 0;
    public medicalAlertTypeDisplayValue: string;
}
